import { Router } from '@angular/router';
import { PlayerService } from './../player/services/player.service';
import { Component, OnInit } from '@angular/core';
import {UserService, ScrollParams, ScrollService} from '../api/';

@Component({
  selector: 'app-my-reports',
  templateUrl: './my-reports.component.html',
  styleUrls: ['./my-reports.component.css']
})
export class MyReportsComponent implements OnInit {
  public onlineOffline: boolean = navigator.onLine;
  private trackingSongs = null;
  private monthlySongsCount: any;
  private monthlyPaidCount: any;

  constructor(private userService: UserService, private scrollService: ScrollService, private playerService: PlayerService, private router: Router) {
    window.addEventListener('online', () => {this.onlineOffline = true;});
    window.addEventListener('offline', () => {this.onlineOffline = false;});
    this.playerService.listenToSongCount.subscribe(res => {
      if(res == true) {
        this.getThisMonthSongsCount();
        this.getAllTimeSongsCount();
        this.getThisMonthPaidCount();
      }
    })
  }

  ngOnInit() {
    let userPackage = localStorage.getItem("package");
    if(userPackage == "5") {
      this.router.navigate(['/']);
    } else {
      this.getThisMonthSongsCount();
      this.getAllTimeSongsCount();
      this.getThisMonthPaidCount();
    }
  }

  // to get the all time count of songs
  getAllTimeSongsCount() {
    if(this.onlineOffline) {
      this.userService.getSongsPlayedCountReal().subscribe((res) => {
        this.trackingSongs = res;
      });
    }
  }

  // to get the count of songs of current month
  getThisMonthSongsCount() {
    if(this.onlineOffline) {
      this.userService.getCurrentMonthSongsCount().subscribe((res) => {
        this.monthlySongsCount = res;
      });
    }
  }

   // to get the count of songs of current month
  getThisMonthPaidCount() {
    if(this.onlineOffline) {
      this.userService.getCurrentMonthPaidCount().subscribe((res) => {
        this.monthlyPaidCount = res;
      });
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/my-reports/my-reports.component.ts